import { graphql } from "react-relay";

// components
// import { TeamPicker } from '@components/team-picker';

export const paymentConfirmationFragments = {
  org: graphql`
    fragment PaymentConfirmation_org on Org {
      id
      primaryTeam {
        __typename
        ... on Team {
          teamId
          teamName
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }
    }
  `,
  team: graphql`
    fragment PaymentConfirmation_team on Team {
      teamName
      teamId
      teamMembers {
        person {
          profile {
            givenName
            familyName
          }
        }
      }
    }
  `,
};
